import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

interface ErrorBaseOptions {
  clearError?: boolean; 
  reverse?: boolean;
}

@Component
export default class CreateCampaignDialogErrorMixin extends Vue {
  @Prop()
  errorsRaw: any[];

  get errorCondition(): any[] { return [];}

  get errors() {
    return this.getErrors(this.errorCondition);
  }

  getErrors(errorCondition: any[], outIndexes?: number[]) {
    return this.errorsRaw 
      ? this.errorsRaw
        .filter((error, index) => {
          const result = errorCondition.every((item, index) => item === error[index]);
          if(outIndexes && result) {
            outIndexes.push(index);
          }
          return result;
        })
      : [];
  }

  getEmptyEntityError(condition: any[], errorCondition: any[] = null, reverse: boolean = false) {
    return this.getEmptyEntityErrorBase(condition, errorCondition, { reverse }) as boolean;
  }

  getEmptyEntityErrors(condition: any[], errorCondition: any[] = null, reverse: boolean = false) {
    return this.getEmptyEntityErrorBase(condition, errorCondition, {
      clearError: true,
      reverse: reverse
    }) as boolean[];
  }

  getEmptyEntityErrorBase(condition: any[], errorCondition: any[] = null, options: ErrorBaseOptions = {}) {
    const clearError = options.clearError || false;
    const reverse = options.reverse || false;
    //clearError: boolean = false

    let errors: any[] = null;
    let indexes: number[] = clearError ? [] : null;

    if(errorCondition) {
      errors = this.getErrors(errorCondition, indexes);
    } else {
      errorCondition = this.errorCondition;
      errors = this.errors;
    }
    
    const index = errorCondition.length;
    const conditionFunc = (error: any) => {
      for(let i = index, j = 0; j < condition.length; i++, j++) {
        if(error[i] !== condition[j]) {
          return reverse ? true : false;
        }
      }

      return reverse ? false : true;
    }

    if(clearError) {
      let result = errors.map(conditionFunc);
     
      return this.errorsRaw.map((item, i) => {
        let j = indexes.indexOf(i);
        return j !== -1  
          ? result[j]
          : false;
      });
    } else {
      return errors.some(conditionFunc);
    }
  }

  getInvalidFieldsError(condition: any[], errorCondition: any[] = null, reverse: boolean = false) {
    return this.getInvalidFieldsErrorBase(condition, errorCondition, { reverse }) as boolean;
  }

  getInvalidFieldsErrors(condition: any[], errorCondition: any[] = null, reverse: boolean = false) {
    return this.getInvalidFieldsErrorBase(condition, errorCondition, {
      clearError: true,
      reverse: reverse
    }) as boolean[];
  }

  getInvalidFieldsErrorBase(condition: any[], errorCondition: any[] = null, options: ErrorBaseOptions = {}) {
    const clearError = options.clearError || false;
    const reverse = options.reverse || false;

    let errors: any[] = null;
    let indexes: number[] = clearError ? [] : null;

    if(errorCondition) {
      errors = this.getErrors(errorCondition, indexes);
    } else {
      errorCondition = this.errorCondition;
      errors = this.errors;
    }

    const index = errorCondition.length;
    const conditionFunc = (error: any) => reverse 
      ? !condition.includes(error[index]) 
      : condition.includes(error[index]
    );

    if(clearError) {
      let result = errors.map(conditionFunc);
      
      return this.errorsRaw.map((item, i) => {
        let j = indexes.indexOf(i);
        return j !== -1  
          ? result[j]
          : false;
      });
    } else {
      return errors.some(conditionFunc);
    }
  }

  getMessages(isError: boolean) {
    return isError
      ? 'error' 
      : null;
  }
}